import React from "react";
import { Switch, Redirect } from "react-router-dom";
import themeAfiliado from "../Theme/themeAfiliado";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { CssBaseline, makeStyles } from "@material-ui/core";
import { Alertas } from "../components/ui/Alertas";
import Spinner from "../components/ui/BackDrop";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { HomeAfiliado } from "../components/webAfiliado/home/HomeAfiliado";
import { Contacto } from "../components/webAfiliado/contacto/Contacto";
import Credenciales from "../components/webAfiliado/credenciales/Credenciales";
import InformacionAfiliado from "../components/webAfiliado/InformacionAfiliado";
import LoginScreenAfiliado from "../components/webAfiliado/auth/LoginScreenAfiliado";
import RegisterScreen from "../components/webAfiliado/auth/RegisterScreen";
import Facturas from "../components/webAfiliado/Facturacion/FacturasAfiliado";

import AppBarAfiliado from "../components/webAfiliado/bar/appBar";
import FooterAfiliado from "../components/webAfiliado/bar/footer";
import { OlvidePasswordScreen } from "../components/webAfiliado/auth/OlvidePasswordScreen";

import { RestaurarPasswordScreen } from "../components/webAfiliado/auth/RestaurarPasswordScreen";
import Turnos from "../components/webAfiliado/turnos/Turnos";
import SacarTurno from "../components/webAfiliado/turnos/SacarTurno";
import MiPerfilContainer from "../components/webAfiliado/MiPerfil/MiPerfilContainer";
import MisTurnos from "../components/webAfiliado/turnos/MisTurnos";
import { Farmacias } from "../components/webAfiliado/farmacias/Farmacias";
import { Helmet } from "react-helmet";
import SetEmailScreen from "../components/webAfiliado/auth/SetEmailScreen";
import SelectDateScreen from "../components/webAfiliado/auth/SelectDateScreen";
import Formularios from "../components/webAfiliado/formularios/Formularios";
import HistorialAtencion from "../components/webAfiliado/turnos/HistorialAtencion";
import NotificacionTurnoPrestadorExterno from "../components/webAfiliado/NotificacionTurnoPrestadorExterno";
import { CancelarTurnoScreen } from "../components/webAfiliado/turnos/CancelarTurnoScreen";
import { Cartilla } from "../components/webAfiliado/cartilla/Cartilla";
import { MiCartilla } from "../components/webAfiliado/cartilla/MiCartilla";
import ControlRecetaDigital from "../components/webAfiliado/ControlRecetaDigital";
import { DiscapacidadAfi } from "../components/webAfiliado/discapacidad/DiscapacidadAfi";
import { MisSolicitudes } from "../components/webAfiliado/discapacidad/MisSolicitudes";
import { NuevaSolicitud } from "../components/webAfiliado/discapacidad/nuevaSolicitud/NuevaSolicitud";
import { SalaEspera } from "../components/HCE/telemedicina/SalaEspera";
import { SalaEsperaAfiliado } from "../components/HCE/telemedicina/SalaEsperaAfiliado";
import { Teleconsulta } from "../components/HCE/telemedicina/Teleconsulta";
import { HomeFormularioWeb } from "../components/afiliaciones/formularioWeb/HomeFormularioWeb";
import { EstadoTurnoScreen } from '../components/webAfiliado/turnos/EstadoTurnoScreen';
import { AbonarTurnoScreen } from '../components/webAfiliado/turnos/AbonarTurnoScreen';
import { ControlCertificadoAtencion } from "../components/webAfiliado/turnos/ControlCertificadoAtencion";


const useStyles = makeStyles((theme) => ({
    root: {
        height: "calc(100vh - 64px)"
    }
}));

export const AfiliadoRouter = () => {
    const classes = useStyles()
    return (
        <MuiThemeProvider theme={themeAfiliado}>
            <CssBaseline />
            <Alertas />
            <Spinner />
            <AppBarAfiliado />
            <div className={classes.root}>
                <Helmet>
                    <title>Mi OSPEDYC</title>
                </Helmet>
                <Switch>
                    <PublicRoute
                        path="/afiliado/credenciales/informacion-afiliado/:idAfiliado"
                        component={InformacionAfiliado}
                    />
                    <PublicRoute
                        path="/afiliado/control-receta-digital/:idReceta"
                        component={ControlRecetaDigital}
                    />
                    <PublicRoute
                        path="/afiliado/prestador/enviar-notificacion-afiliado/:idRegistroAtencion"
                        component={NotificacionTurnoPrestadorExterno}
                    />
                    <PublicRoute
                        path="/afiliado/ingreso"
                        component={LoginScreenAfiliado}
                    />
                    <PublicRoute
                        path="/afiliado/registro"
                        component={RegisterScreen}
                    />
                    <PublicRoute
                        path="/afiliado/registro-sin-email/:nroDocumento/:fechaNacimiento"
                        component={SetEmailScreen}
                    />
                    <PublicRoute
                        path="/afiliado/registro-sin-email/:nroDocumento"
                        component={SelectDateScreen}
                    />
                    <PublicRoute
                        path="/afiliado/olvide-password"
                        component={OlvidePasswordScreen}
                    />
                    <PublicRoute
                        path="/afiliado/restaurar-password/:token"
                        component={RestaurarPasswordScreen}
                    />
                    <PublicRoute
                        exact
                        path="/afiliado/informacion/:idAfiliado"
                        isAuthenticated={false}
                        component={InformacionAfiliado}
                    />
                    <PublicRoute
                        exact
                        noRedirect={true}
                        path="/afiliado/turnos/cancelar-turno/:idAgenda"
                        isAuthenticated={false}
                        component={CancelarTurnoScreen}
                    />
                    <PublicRoute
                        exact
                        noRedirect={true}
                        path="/afiliado/turnos/turno-estado/:idAgenda"
                        isAuthenticated={false}
                        component={EstadoTurnoScreen}
                    />
                    <PublicRoute
                        exact
                        noRedirect={true}
                        path="/afiliado/turnos/abonar-turno/:idAgenda"
                        isAuthenticated={false}
                        component={AbonarTurnoScreen}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/turnos"
                        rutaAfiliado={true}
                        component={Turnos}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/turnos/historial-de-atencion"
                        rutaAfiliado={true}
                        component={HistorialAtencion}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/turnos/sacar-turno"
                        rutaAfiliado={true}
                        component={SacarTurno}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/turnos/mis-turnos"
                        rutaAfiliado={true}
                        component={MisTurnos}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/inicio"
                        rutaAfiliado={true}
                        component={HomeAfiliado}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/mi-perfil"
                        rutaAfiliado={true}
                        component={MiPerfilContainer}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/datos-contacto/:idAfiliado"
                        rutaAfiliado={true}
                        component={MiPerfilContainer}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/contactos"
                        rutaAfiliado={true}
                        component={Contacto}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/cartilla"
                        rutaAfiliado={true}
                        component={Cartilla}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/mi-cartilla"
                        rutaAfiliado={true}
                        component={MiCartilla}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/farmacias"
                        rutaAfiliado={true}
                        component={Farmacias}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/formularios"
                        rutaAfiliado={true}
                        component={Formularios}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/credenciales"
                        rutaAfiliado={true}
                        component={Credenciales}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/facturas"
                        rutaAfiliado={true}
                        component={Facturas}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/discapacidad"
                        rutaAfiliado={true}
                        component={DiscapacidadAfi}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/discapacidad/nueva-solicitud"
                        rutaAfiliado={true}
                        component={NuevaSolicitud}
                    />
                    <PrivateRoute
                        exact
                        path="/afiliado/discapacidad/mis-solicitudes"
                        rutaAfiliado={true}
                        component={MisSolicitudes}
                    />
                    <PublicRoute
                        path="/afiliado/salaespera"
                        component={SalaEspera}
                    />
                    <PublicRoute
                        path="/afiliado/salaesperaafiliado"
                        component={SalaEsperaAfiliado}
                    />
                    <PublicRoute
                        path="/afiliado/salaTelemedicina"
                        component={Teleconsulta}
                    />
                    <PublicRoute
                        path="/afiliado/formularioAfiliacion"
                        component={HomeFormularioWeb}
                    />
                    <PublicRoute
                        path="/afiliado/certificadoAtencion/:id"
                        component={ControlCertificadoAtencion}
                    />
                    <Redirect to="/afiliado/ingreso" />
                </Switch>
                <FooterAfiliado />
            </div>
        </MuiThemeProvider>
    );
};
